module.exports = __webpack_public_path__ + "static/media/group-maker.713f9fc6.png";